import styled from 'styled-components';
import { Body } from 'components/Typography';
import DefaultButton from 'components/Buttons/AddButton';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div``;

// TODO: TFR-44 move to container group
export const Fragment = styled.div``;

// TODO: TFR-44 move to typography group
export const MainText = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
  font-weight: 600;
`;

// TODO: TFR-45:Text make unique name or do not export
export const Text = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Button = styled(DefaultButton)``;
